<template>
    <div class="call">
        <div class="call-ctx" v-if="styleType == 2">
          <div class="call-tab">
            <div class="call-tab-item" :class="{'call-tab-active': tab == t.key}" @click="tab = t.key" v-for="t in tabList" :key="t.key">{{ t.title }}</div>
            <a :href="live.tw_url" class="call-tab-more" v-if="live && live.tw_url" v-show="tab == 1">
              <div class="call-more-title">查看更多</div>
              <div class="icon-right call-more-icon"></div>
            </a>
          </div>
          <div class="call-content">
            <div class="call-list" v-show="tab == 1">
              <div class="call-item" v-for="(s, i) in collect" :key="i" @click="goToLink(i)">
                <div class="call-img" :class="{cover: i !== cur}" :style="{backgroundImage: s.url ? `url(${s.url})` : ''}"></div>
                <div class="call-info">
                  <div class="call-name">{{s.desc}}</div>
                  <div class="live-status" :class="[`live-status-${s.status}`]">
                    <div class="live-status-icon"></div>
                    <div class="live-status-title">{{s.statusText}}</div>
                  </div>
                </div>
              </div>
            </div>
            <image-live :url="live.tw_url" v-show="tab == 2" v-if="live && live.tw_url"/>
          </div>
        </div>
        <div class="call-ctx" v-else>
          <div class="call-ti">
            <!--            <div class="icon-live call-ti-icon"></div>-->
            <div class="call-ti-text"></div>
          </div>
          <div class="call-list" v-if="type == 0">
            <div class="call-item call-item-line" v-for="(s, i) in collect" :key="i" @click="goToLink(i)">
              <div class="call-name ellipsis">{{s.desc}}</div>
              <div class="call-start-time" v-if="showStart">{{s.startTime}}</div>
              <div class="call-status" :class="[`call-status-${s.status}`]">{{ i === cur ? '播放中' : s.statusText }}</div>
            </div>
          </div>
          <div class="call-list" v-else>
            <div class="call-item" v-for="(s, i) in collect" :key="i" @click="goToLink(i)">
              <div class="call-img" :class="{cover: i !== cur}" :style="{backgroundImage: `url(${s.url || defaultCover})`}"></div>
              <div class="call-info">
                <div class="call-name ellipsis">{{s.desc}}</div>
                <div class="call-start-time" v-if="showStart">开播时间：{{s.startTime}}</div>
                <div class="call-status" :class="[`call-status-${s.status}`]">{{ i === cur ? '播放中' : s.statusText }}</div>
              </div>
            </div>
          </div>
        </div>
        <bind-mobile @bind="handleBind" v-if="ms"></bind-mobile>
        <div class="select-modal" v-if="selectList">
            <div class="select-modal-content">
                <div class="select-modal-title">选择直播</div>
                <div class="select-live-list">
                    <template  v-if="selectList.length > 0">
                        <div class="select-live-item" v-for="item in selectList" :key="item.id" @click="selectLive(item.id)">
                            <div class="select-live-check" :class="{'live-selected': ids.indexOf(item.id) >= 0}"></div>
                            <div class="select-live-cover" :style="{backgroundImage: `url(${item.url})`}"></div>
                            <div class="select-live-info">
                                <div class="select-live-title">{{item.desc}}</div>
                                <div class="select-live-time">{{item.timeRange}}</div>
                            </div>
                        </div>
                    </template>
                    <div class="tip" v-else>暂无直播可选</div>
                </div>
                <div class="select-modal-btn" :class="{'btn-disable': ids.length <= 0}" @click="confirmSelect">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getSub} from "@/common/auth";
    import {getInfo, getToken} from "@/common/storage";
    import {getDate, isUrl, getTimePeriod, overscroll} from "@/common/tool";
    import bindMobile from "../components/bind-mobile";
    import imageLive from "../components/image-live";
    import auth from "../common/auth";
    import wx from "wx"
    import {dealLive, getNumConf} from "@/common/live";

    export default {
        name: "like",
        components: {
            bindMobile,
            imageLive
        },
        props: {
            info: Object,
            colors: {
                type: Object,
                default() {
                    return {};
                }
            },
            type: Number,
            styleType: Number,
            showStart: Boolean
        },
        data () {
            return {
                collect: [],
                tab: 1,
                selectList: null,
                select: null,
                oldSelect: [],
                ids: [],
                cur: -1,
                user: null,
                ms: false,
                whiteList: null,
                defaultCover: 'https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/topic/live.jpg',
                pollTimer: null,
                pollTime: 10000,
                currentCancelToken: null
            }
        },
        computed: {
            id() {
                return this.info ? this.info.id : 0;
            },
            title() {
                return this.info ? this.info.img_title : '';
            },
            live() {
                return this.cur >=0 ? this.collect[this.cur] : null;
            },
            tabList() {
                const res = [];
                if(this.collect.length > 1) {
                    res.push({title: "直播列表", key: 1});
                }
                if(this.live?.tw_url) {
                    res.push({ title: "图片直播", key: 2 });
                }
                return res;
            }
        },
        watch: {
            info() {
                this.init();
            },
            tabList(val) {
                const tab = this.tab;
                const t = val.find(item => item.key == tab);
                if(!t && val.length > 0) {
                    this.tab = val[0].key;
                }
            },
            selectList(val) {
                this.$nextTick(() => {
                    if(val) {
                        overscroll(document.querySelector(".select-live-list"));
                    } else {
                        overscroll(document.querySelector(".content"));
                    }
                })
            }
        },
        created() {
            this.init();
        },
        methods: {
            confirmSelect() {
                let ids = this.ids;
                if(ids.length > 0) {
                    this.$showDialog({
                        title: '提示',
                        text: `确定选择这${ids.length}场直播吗？`,
                        confirmText: '确定',
                        fn: () => {
                            let list = this.ids.map(id => this.selectList.find(s => s.id == id));
                            const whiteList = this.whiteList;
                            this.$axios.request({
                                url: `/activity-live-wlist/${whiteList.id}`,
                                method: 'PATCH',
                                data: {
                                    watch_config: JSON.stringify((this.select || []).concat(list.map(item => {
                                        return {
                                            id: item.id,
                                            desc: item.desc
                                        }
                                    })))
                                }
                            }).then(() => {
                                this.selectList = null;
                                list = [...this.oldSelect, ...list];
                                list.sort((a, b) => a.id - b.id);
                                list.sort((a, b) => a.order - b.order);
                                list.sort((a, b) => a.status - b.status);
                                this.setCollect(list);
                            })
                        }
                    })
                } else if(this.oldSelect.length > 0) {
                    this.selectList = null;
                    this.setCollect(this.oldSelect);
                }
            },
            selectLive(id) {
                let index = this.ids.indexOf(id);
                if(index >= 0) {
                    this.ids.splice(index, 1);
                } else {
                    let info = this.info;
                    if(info.live_video_limit && this.ids.length + this.oldSelect.length >= info.live_video_limit) {
                        this.$toast(`最多只能选择${info.live_video_limit - this.oldSelect.length}场直播`);
                        return;
                    }
                    this.ids.push(id);
                }
            },
            init() {
                let info = this.info;
                if(info) {
                    if(info.has_whitelist == 1) {
                        const token = getToken();
                        if(token) {
                            getInfo(user => {
                                this.user = user;
                                if(user.live_mobile) {
                                    this.getWhiteList();
                                } else {
                                    this.ms = true;
                                }
                            })
                        } else {
                            this.$showDialog({
                                title: '提示',
                                text: '您尚未登录，请先授权登录！',
                                confirmText: '授权登录',
                                cancelText: false,
                                fn: auth
                            })
                        }
                    } else {
                        this.getLiveCollect();
                    }
                }
            },
            getWhiteList() {
                const user = this.user;
                const id = this.id;
                const url = `/activity-live-wlist?pageSize=1&filter[mobile]=${user.live_mobile}&filter[live_id]=${id}`;
                this.$axios(url).then(res => {
                    const list = res.data;
                    if(list.length > 0) {
                        let item = list[0];
                        // 限制了可观看直播数
                        if(this.info.is_config_video == 1) {
                            if(item.watch_config) {
                                try {
                                    this.select = JSON.parse(item.watch_config);
                                } catch (e) {
                                    console.error(e);
                                    this.select = false;
                                }
                            } else {
                                this.select = false;
                            }
                        }
                        this.whiteList = item;
                        this.getLiveCollect();
                    } else {
                        this.$showDialog({
                            title: '提示',
                            text: `您当绑定手机号为：${user.live_mobile}，此手机号码没有权限观看此直播！`,
                            confirmText: '重新绑定',
                            cancelText: "关闭",
                            fn: () => {
                              this.ms = true;
                            },
                            onCancel: () => {
                              wx.closeWindow();
                            }
                        })
                    }
                });
            },
            handleBind(user) {
                this.user = user;
                this.ms = false;
                this.getWhiteList();
            },
            cancelCurrentRequest() {
                if(this.currentCancelToken) {
                    this.currentCancelToken.cancel();
                    this.currentCancelToken = null;
                }
            },
            goToLink(i) {
                this.cancelCurrentRequest();
                let s = this.collect[i];
                if(isUrl(s.link)) {
                    if(s.is_live == 0) {
                        location.href = s.link;
                    } else {
                        this.cur = i;
                        this.$emit("change", s);
                    }
                }
            },
            checkSub (type, i) {
                let token = getToken();
                if(token) {
                    if(token.subscribe == 0) {
                        getSub(sub => {
                            this.sub = sub;
                            if(sub == 0) {
                                this.$showModal();
                            } else {
                                if(type == "like") {
                                    this.like(i)
                                }
                            }
                        })
                    } else {
                        if(type == "like") {
                            this.like(i)
                        }
                    }
                } else {
                    this.$showDialog({
                        title: '提示',
                        text: '您尚未登录授权，请先授权登录',
                        confirmText: '授权登录',
                        fn: () => {
                            auth();
                        }
                    });
                }
            },
            like (i) {
                let s = this.collect[i];
                this.$axios({
                    url: "/activity-img/praise",
                    method: 'POST',
                    data: {
                        id: s.id
                    }
                }).then(() => {
                    let count = s.praise_count * 1 + 1;
                    this.$set(s, "praise_count", count);
                    this.$toast("已投票");
                })
            },
            getDoubleText (num) {
                return num > 9 ? num : '0' + num;
            },
            getLiveCollect() {
                let id = this.id;
                this.$axios({
                    url: "/activity-img?sort=order&page=1&pageSize=100&filter[al_id]=" + id
                }).then(res => {
                    this.dealList(res.data);
                })
            },
            dealList (data) {
                data.forEach(item => {
                    item.startTime = getDate(item.start_time).pattern("yyyy-MM-dd HH:mm");
                    item.timeRange = getTimePeriod(item.start_time, item.end_time);
                    dealLive(item);
                    item.numConf = getNumConf(item.start_time, item.end_time, item.view_count, item.status, item.statusText);
                });
                data.sort((a, b) => a.status - b.status);
                const now = Date.now();
                // 当前时间段可选择的列表：未设置可选时间段 或者 当前时间在可选时间段范围内
                const periodList = data.filter(item => {
                    let start = item.select_time ? getDate(item.select_time).getTime() : 0,
                        end = item.select_end_time ? getDate(item.select_end_time).getTime() : 0;
                    return !((start && start > now) || (end && end < now));
                });
                const select = this.select;
                if(select === null) {
                    this.setCollect(data);
                } else if(select === false){
                    this.showSelect(periodList);
                } else {
                    // 当前时间点 已选择的列表
                    const list = periodList.filter(item => select.findIndex(s => item.id == s.id) >= 0);
                    // 当前时间点 排除掉已选择的可选列表
                    const selectList = periodList.filter(item => !list.find(s => item.id == s.id));
                    const limit = this.info.live_video_limit;
                    // 存在未选可选的直播 且 未限制数量或未超过已选择的数量限制 弹框继续选择
                    if((!limit || limit > list.length) && selectList.length > 0) {
                        this.showSelect(selectList);
                        this.oldSelect = list; // 已选择的列表
                    } else {
                        this.setCollect(list);
                    }
                }
            },
            showSelect(data) {
                this.selectList = data;
            },
            setCollect(data) {
                this.cur = 0;
                if(data.length > 0) {
                    if(data[0].is_live != 0) {
                        this.cur = 0;
                        this.$emit("change", data[0]);
                    }
                } else {
                    const info = this.info || {};
                    data = [
                        {
                            ...info,
                            is_live: 1,
                            isActivityLive: true,
                            desc: info.title,
                            url: info.cover,
                            start_time: info.start_time,
                            end_time: info.end_time,
                            status: info.status,
                            statusText: info.statusText,
                            startTime: getDate(info.start_time).pattern("yyyy-MM-dd HH:mm"),
                        }
                    ]
                    this.$emit("change", data[0]);
                }
                this.collect = data;
                this.startPoll();
            },
            startPoll() {
                if(this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
                this.pollTimer = setInterval(() => {
                    this.pollCurrentLive();
                }, this.pollTime);
            },
            pollCurrentLive() {
                if(this.cur < 0 || !this.collect || this.collect.length === 0) return;
                const currentLive = this.live;
                if(!currentLive || currentLive.status !== 1) return;
                
                this.cancelCurrentRequest();
                
                const pollingCur = this.cur;
                let url = '';
                if(currentLive.isActivityLive) {
                    url = `/activity-live/detail?alias=${this.info.alias}`;
                } else {
                    url = `/activity-img/${currentLive.id}`;
                }
                
                const source = this.$axios.CancelToken.source();
                this.currentCancelToken = source;
                
                this.$axios({
                    url,
                    method: 'GET',
                    loadingText: false,
                    cancelToken: source.token
                }).then(data => {
                    if(this.cur !== pollingCur) return;
                    if (this.live?.isActivityLive) {
                        const conf = JSON.parse(data.num_config);
                        data.view_count = conf.num;
                    } else {
                        data.numConf = getNumConf(data.start_time, data.end_time, data.view_count, data.status, data.statusText);
                    }
                    dealLive(data);
                    delete currentLive.numberRange;
                    delete currentLive.numberSet;
                    delete currentLive.view_count;
                    this.$set(this.collect, this.cur, { ...currentLive, ...data});
                    if(this.cur >= 0) {
                        this.$emit("change", this.collect[this.cur]);
                    }
                }).catch((err) => {
                    if(!this.$axios.isCancel(err)) {
                        console.log("更新直播热度失败：", err);
                    }
                }).finally(() => {
                    this.currentCancelToken = null;
                });
                
            }
        },
        beforeDestroy() {
            if(this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
            this.cancelCurrentRequest();
        }
    }
</script>

<style scoped lang="less">
    .call {
        padding: 24px;
        background-color: #FFFFFF;
        color: #333333;
    }
    .call-ti {
        display: flex;
        align-items: center;
    }
    .call-ti-icon {
        margin-right: 16px;
        font-size: 42px;
        line-height: 42px;
        color: #00AAFF;
    }
    .call-ti-text {
        width: 175px;
        height: 47px;
        background: url(../assets/live-title.png) center / contain no-repeat;
    }
    .call-item {
        display: flex;
        align-items: center;
        margin-top: 40px;
        font-size: 28px;
        &:hover {
            background-color: #FBFBFB;
        }
        &.call-item-line {
            height: 40px;
            .call-name {
                flex: 1;
                min-width: 0;
            }
            .call-start-time {
                margin-left: 24px;
            }
        }
    }
    .call-start-time {
        color: #666666;
        font-size: 24px;
        line-height: 34px;
    }
    .call-status {
        margin-left: 24px;
        width: 104px;
        height: 34px;
        border-radius: 34px;
        text-align: center;
        line-height: 34px;
        color: #ffffff;
        font-size: 24px;
        &.call-status-1 {
            background-color: #07C160;
        }
        &.call-status-2 {
            background-color: #F8B62D;
        }
        &.call-status-3 {
            background-color: #CC3932;
        }
    }
    .call-img  {
        flex-shrink: 0;
        position: relative;
        width: 244px;
        height: 140px;
        background: center no-repeat;
        background-size: cover;
        &.cover {
            &::before {
                content: '\e601';
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.3);
                font-family: iconfont;
                font-size: 60px;
                color: var(--back-font-color);
            }
        }
        .living {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 6px 10px;
            background-color: var(--warn-color);
            font-size: 24px;
            color: var(--back-font-color);
        }
    }
    .call-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        margin-left: 24px;
        height: 140px;
        min-width: 0;
        .call-status {
            position: absolute;
            top: 0;
            right: 0;
        }
        .call-name {
            padding-right: 120px;
            font-weight: 500;
            line-height: 40px;
        }
        .call-start-time {
            margin-top: 16px;
        }
    }
    .call-other {
        margin-top: 8px;
    }
    .start-time {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: 4px 8px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        font-weight: 200;
        color: var(--back-font-color);
        font-size: 24px;
        line-height: 1.2;
    }
    .like-count {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0 10px;
        height: 30px;
        background-color: rgba(0,0,0,.85);
        border-top-left-radius: 4px;
        line-height: 30px;
        font-size: 20px;
        opacity: 0.7;
    }
    .call-like {
        flex-shrink: 0;
        margin-left: 20px;
        width: 58px;
        height: 58px;
        border-radius: 100%;
        background-color: #F6E29A;
        font-size: 30px;
        line-height: 58px;
        text-align: center;
        color: #BB1127;
    }
    .select-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.75);
        z-index: 1;
    }
    .select-modal-content {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        padding: 24px;
        width: 670px;
        height: 90vh;
        background-color: var(--back-grey-color);
        border-radius: 20px;
        color: var(--title-font-color);
    }
    .select-modal-title {
        text-align: center;
        font-size: 32px;
    }
    .select-live-list {
        flex: 1;
        min-height: 0;
        margin: 20px 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .select-live-item {
        display: flex;
        margin-top: 16px;
        padding: 16px;
        border-radius: 16px;
        background-color: var(--back-white-color);
    }
    .select-live-check {
        margin-top: 38px;
        width: 48px;
        height: 48px;
        border-radius: 100%;
        border: 1px solid rgba(0,0,0,.3);
        &.live-selected {
            border-color: #099AFF;
            background: #099AFF url(../assets/check.png) center / 24px 18px no-repeat;
        }
    }
    .select-live-cover {
        margin: 0 16px;
        width: 220px;
        height: 124px;
        background: center / cover no-repeat;
    }
    .select-live-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-width: 0;
    }
    .select-live-title {
        line-height: 1.5;
    }
    .select-live-time {
        margin-top: 16px;
        font-size: 24px;
        color: var(--tip-font-color);
    }
    .select-modal-btn {
        border-radius: 96px;
        background-color: #099AFF;
        text-align: center;
        color: var(--back-font-color);
        font-size: 36px;
        line-height: 96px;
    }
</style>
